import { render, staticRenderFns } from "./footGuide.vue?vue&type=template&id=05d26729&scoped=true&"
import script from "./footGuide.vue?vue&type=script&lang=js&"
export * from "./footGuide.vue?vue&type=script&lang=js&"
import style0 from "./footGuide.vue?vue&type=style&index=0&id=05d26729&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d26729",
  null
  
)

export default component.exports